import {
    createMountsKompasFrameConfig,
    createMountsKompasHorizontalConfig,
    createMountsKompasMullionsConfig,
    createMountsKompasVerticalConfig,
} from "../../base";

import { IComponentConfig } from "@/app/@types/base-component";
import { Partition } from "@/app/domain/entities/partition";
import { MountsService } from "@/app/services/mounts.service";

const createSlidingDoorMountsKompasFrameConfig = (
    partition: Partition,
): IComponentConfig => {
    const perimeter = MountsService.getPertimetr(partition);
    const qty = 4;

    return createMountsKompasFrameConfig()
        .qty(qty)
        .width(perimeter)
        .area(perimeter)
        .build();
};

const createSlidingDoorMountsKompasHorizontalConfig = (
    partition: Partition,
): IComponentConfig => {
    const width = MountsService.getTotalWidth(partition);
    const lines = MountsService.getKompasHorizontalLines();
    const length = MountsService.getKompasHorizontallLinesLength(partition, lines);

    return createMountsKompasHorizontalConfig()
        .qty(lines)
        .width(width)
        .area(length)
        .build();
};

const createSlidingDoorMountsKompasVerticalConfig = (
    partition: Partition,
): IComponentConfig => {
    const height = MountsService.getTotalHeight(partition);
    const lines = MountsService.getKompasVerticalLines(partition);
    const length = MountsService.getKompasVerticalLinesLength(partition, lines);

    return createMountsKompasVerticalConfig()
        .qty(lines)
        .width(height)
        .area(length)
        .build();
};

const createSlidingDoorMountsKompasMullionsConfig = (
    partition: Partition,
): IComponentConfig => {
    const width = MountsService.getTotalWidth(partition);

    return createMountsKompasMullionsConfig()
        .qty(0)
        .width(width)
        .area(0)
        .build();
};

export const KompasCGFDoorsConfigs = (partition: Partition) => [
    createSlidingDoorMountsKompasFrameConfig(partition),
    createSlidingDoorMountsKompasHorizontalConfig(partition),
    createSlidingDoorMountsKompasVerticalConfig(partition),
    createSlidingDoorMountsKompasMullionsConfig(partition),
];
